import {AbstractSliderQuestionType} from './abstract-slider-question-type';

export class PerformanceLevelQuestionType extends AbstractSliderQuestionType {

  constructor() {
    super(false);
    this.name = 'performancelevel';
    this.prettyName = 'Performancelevel';
    this.icon = 'trophy';
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/performance-level-question-type.ts